function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import { Util } from '../index';
import ContenidoVentana from './contenido-ventana';
import VisorImagenes from '../visor-imagenes/components/visor-imagenes';
import AreaImagen from '../visor-imagenes/components/area-imagen';
import AreaMiniaturas from '../visor-imagenes/components/area-miniaturas';
import BotoneraAreaImagenVisorDerecha from '../visor-imagenes/components/botonera-area-imagen-visor-derecha';
import BotoneraAreaImagenVisorIzquierda from '../visor-imagenes/components/botonera-area-imagen-visor-izquierda';
import ContenidosVisor from '../visor-imagenes/components/contenidos-visor';

var vinculoMiniatura = function vinculoMiniatura(numHistoria, numPaso) {
  return 'swf,HISTORIA:' + numHistoria + '.' + numPaso + '.NO';
};

var getImageSrc = function getImageSrc(_ref) {
  var libroId = _ref.libroId,
      numHistoria = _ref.numHistoria,
      numPaso = _ref.numPaso;
  return 'contenido/' + libroId + Util.pad2(numHistoria) + Util.pad2(Number(numPaso)) + '.png';
};

var getImageSrcA = function getImageSrcA(_ref2) {
  var libroId = _ref2.libroId,
      numHistoria = _ref2.numHistoria,
      numPaso = _ref2.numPaso;
  return 'contenido/' + libroId + Util.pad2(numHistoria) + Util.pad2(Number(numPaso)) + 'a.png';
};

var ContenidoTipoHistoriaManualSegundaVentana = function (_Component) {
  _inherits(ContenidoTipoHistoriaManualSegundaVentana, _Component);

  function ContenidoTipoHistoriaManualSegundaVentana(props) {
    _classCallCheck(this, ContenidoTipoHistoriaManualSegundaVentana);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleBotonSiguiente = function () {
      var _this$props = _this.props,
          numHistoria = _this$props.numHistoria,
          numPaso = _this$props.numPaso,
          onBoton = _this$props.onBoton; // const vinculo = vinculoAbrirZona(libroId, numPagina, Number(numPaso) + 1);

      var vinculo = vinculoMiniatura(numHistoria, Number(numPaso) + 1);
      onBoton(vinculo);
    };

    _this.handleBotonAnterior = function () {
      var _this$props2 = _this.props,
          numHistoria = _this$props2.numHistoria,
          numPaso = _this$props2.numPaso,
          onBoton = _this$props2.onBoton;
      var vinculo = vinculoMiniatura(numHistoria, Number(numPaso) - 1);
      onBoton(vinculo);
    };

    _this.state = {
      versionImagen: 'a',
      // en segunda ventana, siempre version de imagen a
      imageSrc: getImageSrc(props),
      imageSrcA: getImageSrcA(props)
    };
    return _this;
  }

  ContenidoTipoHistoriaManualSegundaVentana.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.numPaso !== this.props.numPaso) {
      this.setState({
        imageSrc: getImageSrc(this.props),
        imageSrcA: getImageSrcA(this.props)
      });
    }
  };

  ContenidoTipoHistoriaManualSegundaVentana.prototype.crearVinetas = function crearVinetas() {
    var _props = this.props,
        libroId = _props.libroId,
        numPasos = _props.numPasos,
        numHistoria = _props.numHistoria;
    var vinetas = [];

    for (var numPaso = 1; numPaso <= numPasos; numPaso++) {
      vinetas.push({
        src: 'contenido/' + libroId + Util.pad2(numHistoria) + Util.pad2(numPaso) + 'b.png',
        vinculo: vinculoMiniatura(numHistoria, numPaso)
      });
    }

    return vinetas;
  };

  ContenidoTipoHistoriaManualSegundaVentana.prototype.render = function render() {
    var _props2 = this.props,
        numPaso = _props2.numPaso,
        numPasos = _props2.numPasos,
        txtNumVineta = _props2.txtNumVineta,
        onBoton = _props2.onBoton;
    var vinetas = this.crearVinetas();
    var paso = numPaso;
    var _state = this.state,
        imageSrc = _state.imageSrc,
        imageSrcA = _state.imageSrcA,
        versionImagen = _state.versionImagen;
    return React.createElement(ContenidoVentana, null, React.createElement(VisorImagenes, {
      clasesExtra: 'historia'
    }, React.createElement(AreaImagen, null, React.createElement(BotoneraAreaImagenVisorIzquierda, {
      paso: paso,
      onBotonAnteriorClick: this.handleBotonAnterior,
      txtNumVineta: txtNumVineta
    }), React.createElement(ContenidosVisor, {
      src: imageSrc,
      srcA: imageSrcA,
      versionImagen: versionImagen,
      paso: paso
    }, this.props.children), React.createElement(BotoneraAreaImagenVisorDerecha, {
      versionImagen: versionImagen,
      onBotonTextoClick: false,
      paso: paso,
      numPasos: numPasos,
      onBotonSiguienteClick: this.handleBotonSiguiente
    })), React.createElement(AreaMiniaturas, {
      vinetas: vinetas,
      paso: Number(paso),
      onBoton: onBoton
    })));
  };

  return ContenidoTipoHistoriaManualSegundaVentana;
}(Component);

ContenidoTipoHistoriaManualSegundaVentana.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.string,
  numPagina: t.number,
  numHistoria: t.string,
  numPaso: t.string,
  numPasos: t.number,
  txtNumVineta: t.string,
  onBoton: t.func.isRequired,
  children: t.any
} : {};
export default ContenidoTipoHistoriaManualSegundaVentana;